import ManagerHeader from "./ManagerHeader.js";
import { useEffect, useState } from "react";
import api from "../../api/axios.js";

const LessonLibrary = () => {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get('/api/lessons')
            .then(res => setFiles(res.data || []))
            .catch(err => console.error('Failed to load lessons', err))
            .finally(() => setLoading(false));
    }, []);

    const general = files.filter(f => f.category === "general");
    const positional = files.filter(f => f.category === "positional");

    return (
        <>
            <ManagerHeader />
            <div className="library-wrapper">
                {loading && <p>Loading...</p>}
                {!loading && files.length === 0 && <p>No lessons uploaded yet.</p>}
                {!loading && files.length > 0 && (
                    <>
                        <div className="general-training">
                            <h3>General Training</h3>
                            <ul>
                                {general.map((f, index) => (
                                    <li key={f.id}>
                                        {f.filename}
                                        <img src={`/images/lesson${index + 1}.png`} alt="lesson" />
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="positional-training">
                            <h3>Positional Training</h3>
                            <ul>
                                {positional.map((f, index) => (
                                    <li key={f.id}>
                                        {f.filename}
                                        <img src={`/images/lesson${index + 4}.png`} alt="lesson"  />
                                    </li>

                                ))}
                            </ul>
                        </div>
                    </>
                )}

            </div>
        </>
    );
}

export default LessonLibrary;
